import Cookies from 'js-cookie';
import * as types from '../mutation-types';

// state
export const state = {
    settings: Cookies.getJSON('settings') ? Cookies.getJSON('settings') : [],
    settingValues: Cookies.getJSON('settings.values') ? Cookies.getJSON('settings.values') : {},
    // settings: [],
    // settingValues:  {},
};

// mutations
export const mutations = {
    [types.SETTINGS_SET_SUCCESS](state, data) {
        state.settings = data;

        Cookies.set('settings', JSON.stringify(state.settings), {expires: 1});
    },

    [types.SETTINGS_SET_FAILURE](state, error) {
        // Silent failure
    },

    [types.SETTINGS_VALUES_SET_SUCCESS](state, { setting, values }) {
        state.settingValues[setting.name] = values;

        Cookies.set('settings.values', JSON.stringify(state.settingValues), {expires: 1});
    },

    [types.SETTINGS_VALUES_SET_FAILURE](error) {
        //
    },
};

// actions
export const actions = {
    async fetchSettings({commit}) {
        // Fetch setting
        return window.axios.get(route('settings.index'))
    },

    async fetchSettingValuesFor({commit, state}, setting) {
        return window.axios
            .get(route('settings.values.index', { setting: setting.id }));
    },

    async refreshSettingValuesFor({ commit, dispatch }, setting) {
        const { data } = await dispatch('fetchSettings');

        const settingFromStore = data.data.find(databaseSetting => databaseSetting.name === setting);
        if (typeof settingFromStore === 'undefined') {
            commit(types.SETTINGS_VALUES_SET_FAILURE);
            return;
        }

        commit(types.SETTINGS_SET_SUCCESS, data.data);
        return dispatch('fetchSettingValuesFor', settingFromStore)
            .then((data) => {
                commit(types.SETTINGS_VALUES_SET_SUCCESS, { setting: settingFromStore, values: data.data });
                return data;
            })
            .catch((error) => {
                commit(types.SETTINGS_VALUES_SET_FAILURE, error);
            });

    },

    async refreshSettings({ commit, dispatch }) {
        const { data } = await dispatch('fetchSettings');

        commit(types.SETTINGS_SET_SUCCESS, data.data);
    }
};

// getters
export const getters = {
    settingValuesFor(state) {
        return ({ setting }) => {
            return state.settingValues[setting];
        }
    },
    settingByName: (state) => (name) => {
        return state.settings.find(setting => setting.name === name)
    }
};
